import { Link } from "react-router-dom";
import { ConnectKitButton } from "connectkit";
import PropTypes from "prop-types";

const Header = () => {
    return (
        <nav id="header" role="navigation" aria-label="Main navigation">
          <Link to='/' id='logo' aria-label="Artblocks Infinity Home">Artblocks Infinity</Link>

          <div id="link-containers">
            <Link to="/about" aria-label="About Us">About US</Link>
            <ConnectKitButton showBalance={true} />
          </div>
        </nav>
    );
}

Header.propTypes = {};

export default Header;